import axios from "../../axios";
import { API_CATALOG_API, ORGANIZATION_API } from "../../constants";
import * as actionTypes from "./actionTypes";

import i18next from "i18next";

export const setOrganization = (data, isEmpty = false, isPage = false) => {
  return {
    type: actionTypes.SET_ORGANIZATION,
    organization: data,
    isEmpty,
    isPage,
  };
};

export const setOrganizationDetails = (data) => {
  return {
    type: actionTypes.SET_ORGANIZATION_DETAILS,
    details: data,
  };
};

export const updatedOrganization = () => {
  return {
    type: actionTypes.UPDATE_ORGANIZATION,
  };
};

export const fetchOrganizationStarting = () => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_STARTING,
  };
};

export const addOrganization = (id) => {
  return {
    type: actionTypes.ADD_ORGANIZATION,
    id: id,
  };
};

export const fetchOrganizationFailed = (error) => {
  return {
    type: actionTypes.FETCH_ORGANIZATION_FAILED,
    error: error,
  };
};

export const setInvoicesLegacy = (data) => {
  return {
    type: actionTypes.SET_INVOICES_LEGACY,
    invoices: data,
  };
};
export const setInvoiceLegacy = (data) => {
  return {
    type: actionTypes.SET_INVOICE_LEGACY,
    invoiceData: data,
  };
};

export const setInvoices = (data) => {
  return {
    type: actionTypes.SET_INVOICES,
    invoices: data,
  };
};

export const setCreditNotes = (data) => {
  return {
    type: actionTypes.SET_CREDIT_NOTES,
    creditNotes: data,
  };
};
export const setCreditNote = (data) => {
  return {
    type: actionTypes.SET_CREDIT_NOTE,
    creditNoteData: data,
  };
};

export const deleteOrganization = () => {
  return (dispatch, getState) => {
    const organizationId = getState().organization.id;
    axios
      .delete(`${ORGANIZATION_API}item/${organizationId}`)
      .then((response) => {
        console.log("delete organization​", response.data);
        dispatch(setOrganization({}));
      })
      .catch((error) => {
        console.log("err", error);
        dispatch(fetchOrganizationFailed(error.response.message));
      });
  };
};

//deprecated should not be used for create new organization from partners-area
export const createNewOrganization = (data) => {
  return async (dispatch, getState) => {
    const accountId = getState().auth.info.customerId;

    try {
      const response = await axios.post(
        `${ORGANIZATION_API}item/`,
        JSON.stringify({ ...data, account_id: accountId })
      );
      dispatch(
        setOrganization({
          ...data,
          account_id: accountId,
        })
      );
      dispatch(addOrganization(response.data));
    } catch (error) {
      console.log("err", error);
      /*throw error.response.data.invalid_fields ?
                `${error.response.data.message}: ${Object.keys(error.response.data.invalid_fields).map(key=>' ' + error.response.data.invalid_fields[key])}`:
                error.response.data.message*/

      throw error.response.data.invalid_fields
        ? {
            toast: `${error.response.data.message}: ${Object.keys(
              error.response.data.invalid_fields
            ).map((key) => " " + error.response.data.invalid_fields[key])}`,
            error: error.response.data.invalid_fields,
          }
        : {
            toast: `${i18next.t("Something went wrong")} ${
              error.response.data.context || ""
            }`,
            error: error.response.data.message,
          };
    }
  };
};

export const updateOrganization = ({ country, ...data }) => {
  return async (dispatch, getState) => {
    const accountId = getState().auth.info.customerId;
    const organizationId = getState().organization.id;

    let country_code = country.toUpperCase();

    try {
      const response = await axios.put(
        `${API_CATALOG_API}fiscal_organization/${organizationId}/`,
        JSON.stringify({
          ...data,
          country_code,
        })
      );

      dispatch(
        setOrganization({
          ...response.data,
          country: response.data.country_code.toLowerCase(),
        })
      );
      dispatch(updatedOrganization());
    } catch (error) {
      console.log(
        " error.response.data.invalid_fields :",
        error.response.data.invalid_fields,
        " err ",
        error.message
      );

      throw error.response.data.invalid_fields
        ? {
            toast: `${error.message}: ${Object.keys(
              error.response.data.invalid_fields
            ).map((key) => " " + error.response.data.invalid_fields[key])}`,
            error: error.response.data.invalid_fields,
          }
        : {
            toast: `${i18next.t("Something went wrong")} ${
              error.response.data.context || ""
            }`,
            error: error.response.data.errors,
          };
    }
  };
};
export const getInvoicesLegacy = () => {
  return async (dispatch, getState) => {
    const organizationId = getState().organization.id;

    try {
      const response = await axios.get(
        `${ORGANIZATION_API}item/${organizationId}/invoices`
      );
      console.log("get legacy invoices", response.data);
      dispatch(setInvoicesLegacy(response.data.invoices));
    } catch (error) {
      if (error.response.status == 404) {
        dispatch(setInvoicesLegacy(false));
      } else {
        throw error.response.message;
      }
    }
  };
};

export const getInvoices = () => {
  return async (dispatch, getState) => {
    const organizationId = getState().organization.id;

    try {
      const response = await axios.get(
        `${API_CATALOG_API}fiscal_organization/${organizationId}/invoices`
      );
      console.log("get invoices", response.data);
      dispatch(setInvoices(response.data.invoices));
    } catch (error) {
      if (error.response.status == 404) {
        dispatch(setInvoices(false));
      } else {
        throw error.response.message;
      }
    }
  };
};

export const getInvoiceLegacy = (id) => {
  return async (dispatch, getState) => {
    const organizationId = getState().organization.id;

    try {
      const response = await axios.get(
        `${ORGANIZATION_API}item/${organizationId}/invoices/item/${id}`
      );
      console.log("set legacy invoice", response.data);
      dispatch(setInvoiceLegacy(response.data));
    } catch (error) {
      throw error.response.message;
    }
  };
};

export const getCreditNotes = () => {
  return async (dispatch, getState) => {
    const organizationId = getState().organization.id;

    try {
      const response = await axios.get(
        `${ORGANIZATION_API}item/${organizationId}/credit-notes`
      );
      console.log("get credit-notes", response.data);
      dispatch(setCreditNotes(response.data.credit_notes));
    } catch (error) {
      if (error.response.status == 404) {
        dispatch(setCreditNotes(false));
      } else {
        throw error.response.message;
      }
    }
  };
};

export const getCreditNote = (id) => {
  return async (dispatch, getState) => {
    const organizationId = getState().organization.id;

    try {
      const response = await axios.get(
        `${ORGANIZATION_API}item/${organizationId}/credit-notes/item/${id}`
      );
      console.log("get credit note", response.data);
      dispatch(setCreditNote(response.data));
    } catch (error) {
      throw error.response.message;
    }
  };
};

export const getPaymentDetails = (data) => {
  return async (dispatch, getState) => {
    const accountId = getState().auth.info.customerId;
    const organizationId = getState().organization.id;
    try {
      const response = await axios.get(
        `${ORGANIZATION_API}item/${organizationId}/payment-details`
      );
      console.log("getPaymentDetails", response.data);
      dispatch(setOrganizationDetails(response.data));
    } catch (error) {
      if (error.response.status == 404) {
        dispatch(setOrganizationDetails(false));
      } else {
        throw error.response.message;
      }
    }
  };
};

export const createPaymentDetails = (data) => {
  return async (dispatch, getState) => {
    // const accountId = getState().auth.info.customerId;
    const organizationId = getState().organization.id;

    try {
      const response = await axios.post(
        `${ORGANIZATION_API}item/${organizationId}/payment-details`,
        JSON.stringify(data)
      );
      console.log("setPaymentDetails", response.data);
      dispatch(setOrganizationDetails({ detailsId: response.data }));
    } catch (error) {
      throw error.response.data.invalid_fields
        ? `${error.response.data.message}: ${Object.keys(
            error.response.data.invalid_fields
          ).map((key) => " " + error.response.data.invalid_fields[key])}`
        : error.response.data.message;
    }
  };
};

export const updatePaymentDetails = (data) => {
  return async (dispatch, getState) => {
    const detailsId = getState().organization.detailsId;
    const organizationId = getState().organization.id;

    try {
      const response = await axios.put(
        `${ORGANIZATION_API}item/${organizationId}/payment-details`,
        JSON.stringify({
          ...data,
          id: detailsId,
        })
      );
      console.log("setPaymentDetails", response.data);
      dispatch(setOrganizationDetails(response.data));
    } catch (error) {
      console.log("==============", error);
      throw error.response.data.invalid_fields
        ? `${error.response.data.message}: ${Object.keys(
            error.response.data.invalid_fields
          ).map((key) => " " + error.response.data.invalid_fields[key])}`
        : error.response.data.message;
    }
  };
};

export const getOrganization = (isPage = false) => {
  return async (dispatch, getState) => {
    const accountId = getState().auth.info.customerId;

    try {
      dispatch(fetchOrganizationStarting());
      //const response = await axios.get( `${ORGANIZATION_API}item/?account_id=${accountId}` )

      const response = await axios.get(
        `${API_CATALOG_API}fiscal_organization/?accountId=${accountId}`
      );

      console.log("get organization -===>", response.data);

      /**testing mook**/
      //response.data.vies = true;
      /**testing mook**/

      dispatch(
        setOrganization(
          {
            ...response.data,
            country: response.data.country_code.toLowerCase(),
            status: "enabled", //response.data.is_valid_to_be_invoiced ? 'enabled' : '',

            //country: response.data.country.toLowerCase(),
          },
          false,
          isPage
        )
      );
    } catch (error) {
      dispatch(fetchOrganizationFailed(error.response.message));
      throw error.response.message;
    }
  };
};
